import { Component, Input, OnInit, NgZone} from "@angular/core";
// services
import { BookingService } from "../../../services/booking.service";
import { ValidationService } from "../../../services/validation.service";

import { Subscription } from "rxjs";
import { SimpleChanges } from "@angular/core";

let bookingPriceData = "";

@Component({
  selector: "app-google-pay",
  templateUrl: "./google-pay.component.html",
  styleUrls: ["./google-pay.component.scss"],
})
export class GooglePayComponent implements OnInit {
  constructor(
    private ngZone: NgZone,
    private _bookingService: BookingService,
    private _validationService: ValidationService
  ) {}

  @Input() price;
  @Input() oldprice;
  @Input() isPaymentFormValidate;
  @Input() bookingAmendSection;
  @Input() bookingType;

  ngOnInit(): void {
    window["angularGooglePayComponentReference"] = {
      component: this,
      zone: this.ngZone,
      loadGooglePaymentFunction: (paymentData) =>
        this.googlePaymentData(paymentData),
    };
    this.getPaymentData();
    console.log(this.isPaymentFormValidate, "OnInt");
    console.log(this.price, "price");
  }

  getPaymentData() {
    bookingPriceData = this.price.totalPrice.majorAmount.toString();
    this.paymentRequest.transactionInfo.totalPrice = bookingPriceData;
  }

  googlePaymentData(paymentData) {
    this._bookingService.setGooglePaymentToken(paymentData);
    const val = (this.oldprice = this.price);
    this._bookingService.setOldPriceService(val);
  }
  ngOnChanges(changes: SimpleChanges, event: MouseEvent): void {
    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'price'**************/
    //Write your code here
    this.getPaymentData();
  }

  paymentRequest: google.payments.api.PaymentDataRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: "CARD",
        parameters: {
          allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
          allowedCardNetworks: [
            "AMEX",
            "VISA",
            "MASTERCARD",
            "DISCOVER",
            "INTERAC",
            "JCB",
          ],
        },
        tokenizationSpecification: {
          type: "PAYMENT_GATEWAY",
          parameters: {
            gateway: "adyen",
            gatewayMerchantId: "PortrLtdCOM",
          },
        },
      },
    ],
    merchantInfo: {
      merchantId: "12345678901234567890",
      merchantName: "PortrLtdCOM Test",
    },
    transactionInfo: {
      totalPriceStatus: "FINAL",
      totalPriceLabel: "Total",
      totalPrice: bookingPriceData,
      currencyCode: "GBP",
      countryCode: "GB",
    },
    callbackIntents: ["PAYMENT_AUTHORIZATION"],
  };

  onLoadPaymentData = (event: Event): void => {
    const eventDetail = event as CustomEvent<google.payments.api.PaymentData>;
    this.googlePaymentData(eventDetail.detail);
  };

  onPaymentAuthorizedData: google.payments.api.PaymentAuthorizedHandler = (
    paymentData
  ) => {
    return {
      transactionState: "SUCCESS",
    };
  };

  onPressButton = (event: Event): void => {
    console.log(this.isPaymentFormValidate, "OpenSheet");
    if (!this.isPaymentFormValidate) {
      event.preventDefault();
    } else {
      let element: HTMLElement = document.getElementById("gPay") as HTMLElement;
      element.click();
      console.log("clickGPAy");
    }
  };

  // onClick=(
  //   event :Event
  // ):void=>{

  // }

  onError = (event: ErrorEvent): void => {
    console.error("error", event.error);
  };
}
